import {
  PbiBookmarksProps,
  PbiWebWorkerProps,
  PowerBiReportCenter,
} from "shared-ui/src/shared-features/report-center";
import {
  deleteRestDeleteBookmark,
  getRestBookmarks,
  postRestAddBookmark,
  putRestUpdateBookmark,
} from "@api/bookmarkStore";
import { getNewAccessToken } from "@api/reportStore";
import { useGetEmbedParams } from "../shared-features/report-center/hooks";
import { useClaims } from "../../../auth/ClaimsProvider";

export const CustomerExperienceReportCenter = (props) => {
  const pbiBookmarksDefault: PbiBookmarksProps = {
    useCurrentUser: () => {
      const { getClaimValue } = useClaims();
      const raw = Number(getClaimValue("accountId"));
      return { accountID: Number.isNaN(raw) ? undefined : raw };
    },
    useVirtualAdmin: () => {
      const { isVirtualAdmin } = useClaims();
      return isVirtualAdmin();
    },
    getBookmarks: getRestBookmarks,
    postBookmarks: postRestAddBookmark,
    putBookmarks: putRestUpdateBookmark,
    deleteBookmarks: deleteRestDeleteBookmark,
  };

  const pbiDefaultWebWorker: PbiWebWorkerProps = {
    webWorkerGetNewAccessToken: getNewAccessToken,
  };

  return (
    <PowerBiReportCenter
      header={props?.header}
      reports={props?.reports}
      pbiBookmarksProps={pbiBookmarksDefault}
      usePbiHook={useGetEmbedParams}
      webWorkerProps={pbiDefaultWebWorker}
      overrideTheme={props?.overrideTheme}
      hideFilters={props?.hideFilters}
      {...props}
    />
  );
};
